// React Basic and Bootstrap
import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import { reviews } from "../../common/data";

//Import Containers
import ReviewsSlider from "../../components/Shared/ReviewsSlider";

const Register = () => {
  return (
    <React.Fragment>

    
      <Container className="pb-lg-4 mb-md-5 mb-4 mt-100 mt-60">
        <Row className="justify-content-center">
          <Col xs="12" className="text-center">
            <div className="section-title">
              <h4 className="title mb-2">
                Build a responsive team.Always stay in touch with customers.
              </h4>
              <p className="text-muted para-desc mx-auto mb-0">
                Manage using Itoagent messaging to monitor employees and visitors from one central dashboard, boosting sales and productivity.
              </p>

              <div className="mt-4">
                <Link to="/register" className="btn btn-primary mt-2 me-2">
                  Let's begin!
                </Link>{" "}
                   {/**
                <Link to="#" className="btn btn-outline-primary mt-2">
                  Free Trial
                </Link>
                      **/}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
}

export default Register;
